import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useQuery } from '@tanstack/react-query'

export const useReviewList = (id: string) => {
  return useQuery({
    ...queries.products.detail(id),
    select: (data) => data?.groupReviews,
  })
}
